import { useChartContext } from '../../ChartProvider';
import { TimeXAxis } from '../timeXAxis';
import { XAxis } from '../xAxis';
import { ClusteringXAxisProps } from './types';

const CLUSTERING_X_KEY = 'clusterPoint';

export const ClusteringXAxis = <T, V = string | number>(
  props: ClusteringXAxisProps<T, V>
) => {
  const { isTimeClustering } = useChartContext();

  if (isTimeClustering) {
    return <TimeXAxis {...props} unixDataKey={CLUSTERING_X_KEY} />;
  }

  return (
    <XAxis
      domain={['dataMin', 'dataMax']}
      type="number"
      {...props}
      dataKey={CLUSTERING_X_KEY}
    />
  );
};
